import { Layout, HealthModal, Modal } from "processhub-components-lib";
import { Suspense, useState, useContext, useEffect } from "react";
import { ModalContext } from "hooks/ModalProvider";
import Header from "components/layout/Header/Header";
import DashboardConfiguration from "components/shared/DashboardConfiguration/DashboardConfiguration";
import Alarms from "pages/alarms/Alarms";
import AllAssets from "pages/all-assets/AllAssets";
import ExpressionContainer from "pages/expressions/ExpressionContainer";
import TagContainer from "pages/tags/TagContainer";
import TicketsContainer from "pages/tickets/TicketsContainer";
import UnityContainer from "pages/unity";
import { Navigate, Route, Routes } from "react-router-dom";
import { AuthGuard } from "utilities/AuthGuard";
import { useSearchParams } from "react-router-dom";
import GuidesModal from "components/guides/GuidesModal";
import "./App.css";
import UsersContainer from "pages/users/UsersContainer";
import UnityLayout from "components/layout/UnityLayout";
import Logs from "pages/Logs";
import Documents from "pages/documents/Documents";
import { Watermark, MinifiedMenu, DxfCanvasViewer } from "processhub-components-lib";
import { dxfCanvasViewerConfig } from "config/dxfCanvasViewerConfig";
import watermarkBg from "assets/watermarkBg.png";
import DataSources from "pages/dataSources/DataSources";
import modalConfig from "config/modal/modalConfig";
import { useMinifiedMenu } from "hooks/useMinifiedMenu";
import allHooks from "hooks";
import { getExtractedPath } from "utilities/extractedPath";
import extractUUIDs from "components/layout/utils/extractUUIDs";
import AiChat from "components/AiChat/AiChat";
import { useAiChat } from "hooks/AiChatContext";
import healthCheckApiConfig from "config/modal/healthCheckApiConfig";
import TabsDashboard from "pages/Dashboard/TabsDashboard";
import InactivityReloader from "utilities/InactivityReloader";
import Projects from "pages/Projects/projects";
import OrganizationAndUsersContainer from "pages/organization-and-users/OrganizationAndUsers";

function App() {

  const [refreshMode, setRefreshMode] = useState('');
  const isLoading = false;
  const [selectedTag, setSelectedTag] = useState<any>({
    action: "",
    value: null,
  });
  const [isMovementDisabled, setIsMovementDisabled] = useState(0);
  const { modalType, setModalType } = useContext(ModalContext);
  const [showHealth, setShowHealth] = useState(false);
  const {
    setMinifiedMenuOpen,
  } = useMinifiedMenu();
  const [searchParams, setSearchParams] = useSearchParams();
  const [showGuidesModal, setShowGuidesModal] = useState(false);

  useEffect(() => {
    if (modalType === '' || modalType === 'report') {
      setMinifiedMenuOpen(true);
    }
    if (modalType !== '' && modalType !== 'report') {
      setMinifiedMenuOpen(false);
    }
    if (modalType === 'tutorials') {
      setShowGuidesModal(true);
    } else {
      setSelectedTag({
        action: modalType,
        value: null,
      });
    }
  }, [modalType]);
  const refresh = async () => { };
  const baseUrl = getExtractedPath();
  const { currOrg, curSol } = extractUUIDs(baseUrl);
  const { aiChatShown } = useAiChat();

  const [menuVisibilityParams, setMenuVisibilityParams] = useState({ left: true, right: true });


  useEffect(() => {
    if (selectedTag.action !== '') {
      setIsMovementDisabled(1);
    }
    else {
      setIsMovementDisabled(0);
    }
  }, [selectedTag]);

  const genModalItems = (mode: 'note' | 'bubble' | 'preview' | 'chart' | 'widget' | 'label' | 'doc' | 'pins' | 'measurements' | 'aiChat', data: any, position: 'left' | 'right') => {
    if (mode === 'aiChat') {
      return (
        <div className="h-full w-full bg-gray/70">
          <AiChat setIsMovementDisabled={setIsMovementDisabled} />
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <InactivityReloader />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route element={<AuthGuard />}>
            <Route element={<Layout><Header setShowHealth={setShowHealth} /></Layout>}>
              <Route path="/new-dashboard" element={<TabsDashboard />} />
              <Route path="/" element={<Navigate to={`/dashboard`} />} />
              <Route path="/dashboard" element={<TabsDashboard />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/dashboard-configuration">
                <Route element={<DashboardConfiguration />}>
                  <Route index element={<Navigate to="/dashboard-configuration/tags" />} />
                  <Route path="tags" element={<TagContainer />} />
                  <Route path="expressions" element={<ExpressionContainer />} />
                  <Route path="documents" element={<Documents />} />
                  <Route path="all-assets" element={<AllAssets />} />
                </Route>
              </Route>
              <Route path="/alarms" element={<Alarms />} />
              <Route path="/tickets" element={<TicketsContainer />} />
              <Route path="/users" element={<UsersContainer />} />
              <Route path="/users-and-projects" element={<OrganizationAndUsersContainer type="users" />} />
              <Route path="/logs" element={<Logs />} />
              <Route path="/data-sources" element={<DataSources />} />
              {/* <Route path="/health" element={<HealthContainer />} /> */}
              <Route path="/dxf" element={<DxfCanvasViewer dxfCanvasViewerConfig={dxfCanvasViewerConfig} hooks={allHooks} colorTheme="default" />} />
            </Route>
            <Route element={<UnityLayout setShowHealth={setShowHealth} />}>
              <Route path="/3d-dashboard" element={<UnityContainer />} />
            </Route>
          </Route>
          <Route path="*" element={<p>Not Found</p>} />
        </Routes>
      </Suspense>
      <Watermark watermarkImage={watermarkBg} />

      <GuidesModal
        activeTab="operational"
        isOpen={showGuidesModal}
        onClose={() => {
          setShowGuidesModal(false);
          setModalType('');
          searchParams.delete("more");
          setSearchParams(searchParams, { replace: true });
        }}
      />

      <Modal hasPointClouds={false} page="tags" setModalType={setModalType} isLoading={isLoading} refresh={refresh} selectedTag={selectedTag} setSelectedTag={setSelectedTag} modalConfig={modalConfig} hooks={allHooks} />
      {
        aiChatShown && !location.pathname.endsWith('/3d-dashboard') &&
        <div className="h-screen w-screen absolute top-0 left-0 z-50 overflow-hidden pointer-events-none">
          <div className="relative h-full w-full">
            <div className="pointer-events-auto">
              <MinifiedMenu genModalItems={genModalItems} allHooks={allHooks} visibilityParams={menuVisibilityParams} setVisibilityParams={setMenuVisibilityParams} />
            </div>
          </div>
        </div>
      }
      {
        showHealth &&
        <div className="absolute left-0 top-0 w-screen h-screen bg-dark/35 flex items-center justify-center align-middle" onClick={() => setShowHealth(false)}>
          <div className="w-[85%] h-[85%] mt-10 z-50 flex items-center justify-center">
            <HealthModal setShowHealth={setShowHealth} healthCheckApiConfig={healthCheckApiConfig} />
          </div>
        </div>
      }
    </>
  );
}

export default App;
